/** A DOM repeat belongs only to the fresh press that armed it. No timers,
 * player calls or global input state; browsers mark orphan repeats explicitly. */
export class KeyboardHold {
  private held = new Map<string, { context: string; repeatable: boolean } | null>();

  press(key: string, context: string, repeat: boolean, repeatable = true): boolean {
    if (!key || !context) return false;
    if (this.held.has(key)) {
      const current = this.held.get(key);
      if (current?.context !== context) this.held.set(key, null);
      return !!current && current.context === context && repeat && repeatable && current.repeatable;
    }
    if (this.held.size >= 32) return false;
    // A repeat first observed after source replacement or focus return cannot
    // become a new press. Its eventual release allows the next real press.
    this.held.set(key, repeat ? null : { context, repeatable });
    return !repeat;
  }
  release(key: string) { this.held.delete(key); }
  cancel() { for (const key of this.held.keys()) this.held.set(key, null); }
  // On blur, releases may go to another window. A new non-repeat recovers;
  // an inherited repeat still cannot arm an action.
  reset() { this.held.clear(); }
}
